import { LogoFull } from "@/lib/helpers/customIcons";
import { cn } from "@/lib/utils";

import styles from "./BrandRow.module.scss";

type BrandRowProps = {
  className?: string;
  tagLabel?: string;
  onClick?: () => void;
};

export const BrandRow = ({
  className,
  tagLabel = "AGENTS.LAB",
  onClick,
}: BrandRowProps): JSX.Element => {
  return (
    <div className={cn(styles.brand_row, className)} onClick={onClick}>
      <LogoFull className={styles.brand_logo} />
      <span className={styles.brand_tag}>{tagLabel}</span>
    </div>
  );
};
